import { isEmpty } from 'lodash';
import { CLEAR_FORM_VALIDATION, SET_SITE_VALIDATION, SET_STUDY_VALIDATION } from 'store/key';
import { produce } from 'utility/general';

const getInitialState = () => {
    return { study: {}, site: {} };
};

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_SITE_VALIDATION:
            if (action.payload.siteInfoId.toString() === '-1' || action.payload.siteInfoId.toString() === 'studyInfo') {
                return state;
            }

            const newSiteState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    if (key !== 'siteInfoId') {
                        if (!draft.site[key]) {
                            draft.site[key] = {};
                        }

                        draft.site[key][action.payload.siteInfoId] = action.payload[key];
                    }
                });
            });

            return newSiteState;
        case SET_STUDY_VALIDATION:
            const newStudyState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    if (!isEmpty(value)) {
                        draft.study[key] = action.payload[key];
                    }
                });
            });
            return newStudyState;

        case CLEAR_FORM_VALIDATION:
            return getInitialState();
        default:
            return state;
    }
};

export function* watchValidation() {
    // yield takeLeading(FETCH_USER_MENU, safeSaga(getUserMenu));
}

export default reducer;
